import { render, staticRenderFns } from "./Circle.vue?vue&type=template&id=639e6f5e&scoped=true&"
import script from "./Circle.js?vue&type=script&lang=js&"
export * from "./Circle.js?vue&type=script&lang=js&"
import style0 from "./Circle.scss?vue&type=style&index=0&id=639e6f5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e6f5e",
  null
  
)

export default component.exports